import React, { useState, useRef, useEffect } from "react";
import "./QuizBuilder.css";
import QuizTemplatePreview from "./QuizTemplatePreview";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";

const QuizSidebarTemplatePreview = ({ templates, onSelectTemplate }) => {
  const [isOpen, setIsOpen] = useState(false);
  const sidebarRef = useRef(null);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOutside = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      {!isOpen && (
        <button onClick={toggleSidebar} className="quiz-sidebar-toggle">
          Add Quiz
        </button>
      )}
      <div ref={sidebarRef} className={`quiz-sidebar ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="quiz-sidebar-content">
            {templates.map((template, index) => (
              <div
                key={index}
                className="quiz-template-preview"
                onClick={() => onSelectTemplate(template)}
              >
                <div className="quiz-template-name">{template.name}</div>
                <div className="quiz-template-preview-container">
                  <QuizTemplatePreview template={template} />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default QuizSidebarTemplatePreview;
